module.exports = __webpack_public_path__ + "static/media/webdesign-services-img56.eb6f5c5d.jpg";